export default {"src":"/pro/_next/static/media/benji.6a38a136.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};